var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',_vm._l((_vm.slugs),function(slug){return _c('div',[_c('v-chip',{attrs:{"color":"blue-grey lighten-5"}},[_c('v-avatar',{attrs:{"size":"16px"}},[_c('img',{attrs:{"src":_vm.iconURLs[slug.icon]}})]),_vm._v("\n          "+_vm._s(slug.name)+"\n  ")],1),_vm._v(" "),_c('v-btn',{attrs:{"href":slug.downloadURL}},[_vm._v("\n      Download\n    ")])],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8f9d2fa2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/DataSlug.vue
// module id = 1DyT
// module chunks = 1